import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
  Snackbar,
  Chip,
  // PaginationItem,
} from "@mui/material";

// all imports
import DashboardLayout from "../../layout/DashboardLayout.js";
import { getSearches } from "../../services/userService.js";
import { grey } from "@mui/material/colors";

function Searches() {
    const location = useLocation();
    const navigate = useNavigate();
    const [searches, setSearches] = useState([]);
    // Extract search query from URL parameters
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const query = params.get('q') || params.get('query') || '';
        const page = params.get('page') || 1; 
        const fetchSearches = async () => {
            const response = await getSearches();
            if (response.status === 'success') {
                setSearches(response.data);
            } else {
                setShowErrorAlert(true);
                setTimeout(() => {
                    setErrorMessage(false);
                }, 2000);
            }
        }
        fetchSearches();
    }, [location.search, location.pathname]);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const handleSearchClick = async (searchTerm) => {
        navigate(`/search?query=${searchTerm}&page=1`);
      };

       // Helper function to format date
    const formatDateOnly = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (error) {
            return dateString; // Return original string if parsing fails
        }
    };

    return (
        <DashboardLayout pageName="Search">
            <Snackbar open={showErrorAlert} autoHideDuration={6000} onClose={() => setShowErrorAlert(false)}>
                <Alert onClose={() => setShowErrorAlert(false)} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>

            <Box sx={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', m:2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#0a1128', borderRadius: 1, boxShadow: 2, p: 2  , mb:-2, width: '100%' }}>
                    <Typography variant="h5" sx={{ fontWeight: 600, color: '#eff7f6', mb: 2 }}>My Searches</Typography>
                </Box>
      
                <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 2 }}>
                    <Table sx={{ minWidth: 650 }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: grey[200] }}>
                                <TableCell sx={{ fontWeight: 600 }}>S.No</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Search Term</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Dated</TableCell>
                            </TableRow>
                        </TableHead>
                        
                        <TableBody>
                            {searches.map((search, index) => (
                                <TableRow key={search.id} sx={{ '&:hover': { backgroundColor: grey[100] } }}>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '1rem' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '1rem' }}>
                                        <Link component="button" onClick={() => handleSearchClick(search.searchTerm)}>
                                        <Chip sx={{ fontWeight: 600, bgcolor: '#1BE885' }} label={search.searchTerm} />
                                        </Link>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '1rem' }}>{formatDateOnly(search.createdAt)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </DashboardLayout>
    );
}

export default Searches;